<div class="page">
  <span class="eyebrow">Verkstad</span>
  <h1>Service</h1>

  <div class="panel">
    <p>Är du i behov av service? Välkommen in till oss!<br>
      Vi servar de allra flesta märken och årsmodeller.</p>
    <ul class="service-list">
      <li>Rutinservice inför besiktning</li>
      <li>4-hjulsmätningar</li>
      <li>Avancerad felsökning med diagnossystem</li>
      <li>Service av hybrider och elbilar</li>
      <li>Lånebil under tiden du har bilen hos oss</li>
    </ul>
  </div>
</div>
